export default {"src":"/_next/static/media/ic-edit.ab901e40.svg","height":24,"width":24};